import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AtxTagComponent } from './components';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        AtxTagComponent,
    ],
    exports: [
        AtxTagComponent,
    ],
})

export class AtxTagModule {}
